import { useId, useRef, type KeyboardEvent, type ReactNode } from 'react';

export interface TabDef { id: string; label: string; content: ReactNode }

/** Pestañas con patrón WAI-ARIA (flechas, Inicio, Fin). */
export function Tabs({ tabs, active, onChange, label, className }: { tabs: TabDef[]; active: string; onChange: (id: string) => void; label: string; className?: string }) {
  const base = useId();
  const refs = useRef<Array<HTMLButtonElement | null>>([]);
  const idx = Math.max(0, tabs.findIndex((t) => t.id === active));
  const onKey = (e: KeyboardEvent) => {
    let n = idx;
    if (e.key === 'ArrowRight') n = (idx + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') n = (idx - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    else return;
    e.preventDefault();
    onChange(tabs[n].id);
    refs.current[n]?.focus();
  };
  return (
    <div className={className}>
      <div role="tablist" aria-label={label} className="tabs__list" onKeyDown={onKey}>
        {tabs.map((t, i) => (
          <button key={t.id} ref={(el) => { refs.current[i] = el; }} role="tab" id={`${base}-t-${t.id}`}
            aria-selected={i === idx} aria-controls={`${base}-p-${t.id}`} tabIndex={i === idx ? 0 : -1}
            className="tabs__tab" onClick={() => onChange(t.id)}>
            {t.label}
          </button>
        ))}
      </div>
      {tabs.map((t, i) => (
        <div key={t.id} role="tabpanel" id={`${base}-p-${t.id}`} aria-labelledby={`${base}-t-${t.id}`} hidden={i !== idx} className="tabs__panel" tabIndex={0}>
          {i === idx && t.content}
        </div>
      ))}
    </div>
  );
}
